import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    NoWebPushVariant,
    WithWebPushVariant
} from '@client/components/abtesting/webPush';

import {
    PERMISSION_STATUS
} from '@client/helpers/pushNotification/management';

import {
    showPermissionDialog as showPermissionDialogFromRedux,
    showReenablementDialog as showReenablementDialogFromRedux,
    setCampaignToSubscribe as setCampaignToSubscribeFromRedux,
    addCampaignNotificationTag,
    removeCampaignNotificationTag
} from '@client/redux/modules/pushNotification/actions';

import {
    getCampaignNotificationTag,
    getCampaignNotificationTagLoading,
    getIsSupported,
    getRegistrationPossible,
    getIsOptedIn,
    getPermissionStatus
} from '@client/redux/modules/pushNotification/selectors';

import { track } from '@client/helpers';
import configShape from '@client/hoc/config/configShape';
import injectConfig from '@client/hoc/config/injectConfig';
import NotificationReminder from './NotificationReminder';
import CalendarReminder from './CalendarReminder';

export class Reminder extends PureComponent {
    static propTypes = {
        campaign: PropTypes.object.isRequired,
        showPermissionDialog: PropTypes.func.isRequired,
        showReenablementDialog: PropTypes.func.isRequired,
        setCampaignTag: PropTypes.func.isRequired,
        removeCampaignTag: PropTypes.func.isRequired,
        notificationOn: PropTypes.bool.isRequired,
        registrationPossible: PropTypes.bool.isRequired,
        isSupported: PropTypes.bool.isRequired,
        isOptedIn: PropTypes.bool.isRequired,
        permissionStatus: PropTypes.oneOfType([null, PropTypes.string]).isRequired,
        config: configShape,
    }

    render() {
        const {
            campaign,
            isSupported,
            notificationOn,
            notificationTagLoading,
            config
        } = this.props;

        return (!isSupported || !config.isEnabled('pushNotification')) ?
            <CalendarReminder
                campaign={campaign}
                onReminderClick={this.trackReminderClick}
            />
            :
            <Fragment>
                <NoWebPushVariant>
                    <CalendarReminder
                        campaign={campaign}
                        onReminderClick={this.trackReminderClick}
                    />
                </NoWebPushVariant>
                <WithWebPushVariant>
                    <NotificationReminder
                        notificationOn={notificationOn}
                        loading={notificationTagLoading}
                        onReminderClick={this.subscribeToReminder}
                    />
                </WithWebPushVariant>
            </Fragment>;
    }

    subscribeToReminder = () => {
        const {
            campaign: { campaignIdentifier },
            setCampaignTagToSubscribe,
            registrationPossible,
            isOptedIn,
            showReenablementDialog,
            showPermissionDialog,
            permissionStatus
        } = this.props;

        if (isOptedIn) {
            this.manageCampaignSubscription();

            return;
        }

        if (!registrationPossible || permissionStatus === PERMISSION_STATUS.DENIED) {
            setCampaignTagToSubscribe(campaignIdentifier);
            showReenablementDialog();

            return;
        }

        setCampaignTagToSubscribe(campaignIdentifier);
        showPermissionDialog();
    }

    manageCampaignSubscription() {
        const {
            campaign,
            config,
            addCampaignTag,
            removeCampaignTag,
            notificationOn
        } = this.props;

        this.trackReminderClick(campaign, true, notificationOn);
        const { appdomainid } = config;

        if (notificationOn) {
            removeCampaignTag(campaign.campaignIdentifier, appdomainid);
        }
        else {
            addCampaignTag(campaign.campaignIdentifier, appdomainid);
        }
    }

    trackReminderClick = (campaign, isNotification, notificationOn) => track(
        isNotification ? `campaignOverview_calendar_${notificationOn ? 'off' : 'on'}` : 'calendar-click',
        {
            productCampaign: campaign.campaignIdentifier
        }
    );
}

const mapStateToProps = (state, ownProps) => ({
    notificationOn: getCampaignNotificationTag(ownProps.campaign.campaignIdentifier)(state),
    notificationTagLoading: getCampaignNotificationTagLoading(ownProps.campaign.campaignIdentifier)(state),
    registrationPossible: getRegistrationPossible(state),
    isSupported: getIsSupported(state),
    isOptedIn: getIsOptedIn(state),
    permissionStatus: getPermissionStatus(state)
});

const mapDispatchToProps = {
    showPermissionDialog: showPermissionDialogFromRedux,
    showReenablementDialog: showReenablementDialogFromRedux,
    setCampaignTagToSubscribe: setCampaignToSubscribeFromRedux,
    addCampaignTag: addCampaignNotificationTag,
    removeCampaignTag: removeCampaignNotificationTag,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectConfig
)(Reminder);
